import { useMutation } from 'react-query';
import { queryClient } from '../../../../../../../../config/queryClient';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { SocialSecurityComparisonDTO } from './useSocialSecurityComparisonQuery';
import { Params as ComparisonQueryParams } from './useSocialSecurityComparisonQuery';
import { SocialSecurityWhatIf } from './types';
import { queryKeys } from './queryKeys';

export const GET_SOCIAL_SECURITY_COMPARISON_WITH_WHAT_IFS = 'GetSocialSecurityComparisonWithWhatIfsKey';

export interface Params {
  clientId: number;
  fpId: string;
  body: SocialSecurityWhatIf[];
  signal?: AbortSignal;
}

export const fetchSocialSecurityComparisonWithWhatIfs = ({
  clientId,
  fpId,
  body,
  signal,
}: Params): Promise<SocialSecurityComparisonDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OptimizeSocialSecurity/GetSocialSecurityComparisonWithWhatIfs', {
      clientId,
      fpId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(body, true),
      signal,
    },
  );
};

export const useSocialSecurityComparisonWithWhatIfsMutation = ({ clientId, fpId }: Omit<ComparisonQueryParams, 'enabled'>) => {
  return useMutation(fetchSocialSecurityComparisonWithWhatIfs, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.socialSecurityComparison(clientId, fpId));
    },
  });
};
